// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__1KhpK","header":"Main_header__NLDg9","content":"Main_content__1PLJ5","footer":"Main_footer__UC_-7"};